import { MobiDocument } from './MobiDocument';

export class EtablissementScolaireDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private nom: string;
    private obsolete : boolean;


    public constructor(ecole: any) {
        super()
        this._id = ecole._id;
        this._rev = ecole._rev;
        this.id = ecole.id;
        this.nom = ecole.nom;
        this.obsolete = ecole.obsolete;

    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }
    
    public isObsolete(): boolean {
        return this.obsolete;
    }

    public setObsolete(obsolete: boolean): void {
        this.obsolete = obsolete;
    }

}